import usePrivateAxios from '@/common/api/usePrivateAxios'
import { BiddingStatus } from '@/features/publicCompanyLeadsFunnel/types/publicCompanyLead'
import { useMutation } from '@tanstack/react-query'

interface UseChangeBiddingDataProps {
  id?: string
  onSuccess: () => void
  onError: (error: any) => void
}

export const useChangeBiddingData = ({ id, onSuccess, onError }: UseChangeBiddingDataProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['changeBiddingData'],
    mutationFn: async ({ contest_date, status }: { contest_date?: string | null; status?: BiddingStatus }) => {
      const lead = {
        bidding_information_attributes: {
          contest_date,
          status,
        },
      }

      return privateAxios.put(`/funnel/public/leads/${id}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
